<template>
  <div class="container">
    <moduleTitle title="笔试信息"></moduleTitle>
    <div class="table">
      <div class="row">
        <div class="column">应聘部门</div>
        <div class="column">{{ item.ypdwhbm }}</div>
      </div>
      <div class="row">
        <div class="column">应聘岗位</div>
        <div class="column">{{ item.ypgw }}</div>
      </div>
      <div class="row">
        <div class="column">审核结果</div>
        <div class="column">
          <div class="success">{{ item.shjg == "1" ? "通过" : "不通过" }}</div>
        </div>
      </div>
      <div class="row">
        <div class="column">审核意见</div>
        <div class="column">{{ item.shyj }}</div>
      </div>
      <div class="row">
        <div class="column">笔试通知</div>
        <div class="column" @click="toMsg">
          <div class="link">查看笔试通知</div>
        </div>
      </div>
      <div class="row">
        <div class="column">是否确认参加笔试</div>
        <div class="column">
          <div class="danger">{{ item.sfqrcjbs == "1" ? "是" : "否" }}</div>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <el-button type="primary" size="small" @click="confirm(item.zphdbmid)"
        >确认参加笔试</el-button
      >
      <el-button type="primary" size="small" @click="close">关闭</el-button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.success {
  color: #27c18c;
}
.danger {
  color: #ff5858;
}
.link {
  color: #2a8ae0;
  &:hover {
    cursor: pointer;
  }
}
.container {
  width: 80%;
  margin: 40px auto;
  .table {
    width: 80%;
    margin: auto;
    .row {
      border: 1px solid #dcdcdc;
      border-top: 0px;
      display: flex;
      &:first-child {
        border-top: 1px solid #dcdcdc;
      }
      .column {
        padding: 20px;
        text-align: center;
        width: 50%;
        &:first-child {
          border-right: 1px solid #dcdcdc;
          font-weight: bold;
        }
      }
    }
  }
  .footer-btn {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import request from "@/api/jobProgress";
export default {
  components: {
    moduleTitle
  },
  data() {
    return {
      item: {}
    };
  },
  created() {
    this.item = JSON.parse(this.$route.params.data);
  },
  methods: {
    async confirm(id) {
      const para = {
        zphdbmid: id
      };
      await request.confirmWritten(para);
      this.$message({
        type: "success",
        message: "确认成功"
      });
      this.close();
    },
    close() {
      this.$router.push({ name: "JobProgress" });
    },
    /* 查询笔、面试通知 */
    toMsg() {
      this.$router.push({
        path: "/msg",
        query: {
          id: this.item.zphdid
        }
      });
    }
  }
};
</script>
